import api from "./Api";
import ApiLinks from "../Navlinks/ApiLinks";

const FCM_TOKEN_KEY = "webFcmToken";
const FCM_LAST_UPDATE_KEY = "webFcmLastUpdate";
const TEN_HOURS_MS = 10 * 60 * 60 * 1000;

function getBrowserFcmToken() {
  let token = localStorage.getItem(FCM_TOKEN_KEY);
  if (!token) {
    token = crypto.randomUUID();
    localStorage.setItem(FCM_TOKEN_KEY, token);
  }
  return token;
}

async function pushTokenToServer(userId, token) {
  try {
    await api.patch(ApiLinks.User_UpdateWebFcm(userId), { webFcmId: token });
  } catch {
    // non-critical — silent fail
  }
}

export async function initFcm(userId) {
  try {
    const token = getBrowserFcmToken();
    localStorage.setItem(FCM_LAST_UPDATE_KEY, Date.now().toString());
    await pushTokenToServer(userId, token);
  } catch {
    // non-critical — silent fail
  }
}

export async function refreshFcmIfNeeded(userId) {
  try {
    const last = parseInt(localStorage.getItem(FCM_LAST_UPDATE_KEY) || "0", 10);
    if (!last || Date.now() - last >= TEN_HOURS_MS) {
      await initFcm(userId);
    }
  } catch {
    // non-critical — silent fail
  }
}

export function startFcmRefreshInterval(userId) {
  return setInterval(() => {
    refreshFcmIfNeeded(userId);
  }, TEN_HOURS_MS);
}
